import './LoadingChatMessage.less';

const LoadingChatMessage = () => (
    <div className={`bri-AssistantChatMessage bri-LoadingChatMessage`}>
        <span>.</span>
        <span>.</span>
        <span>.</span>
    </div>
);

export default LoadingChatMessage;
